import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule,JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from "jk-advcom";
import { SysuserService } from '../services/sysuser.service';
import { Sysuser } from '../entity/Sysuser-angular';


@Component({
  selector: 'app-sysuser-edit',
  templateUrl: './sysuser-editPkg.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [JackBaseComponentModule, AdvComModule,MaterialModule],
})

export class SysuserEditComponent extends JkDialogEditComponent<SysuserService,Sysuser>{
  override srv!: SysuserService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<SysuserEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject,dialogRef,data);
  }


}
